import React, { Component } from 'react';
import ImageGallery from 'react-image-gallery';
import '../../node_modules/react-image-gallery/styles/css/image-gallery.css';
import photographerImages from "../data/galleries";

class PhotographerGallery extends Component {
    getImages(photographerId){
        var photographer = photographerImages[photographerId];
        var images = [];

        photographer.photos.forEach(photo => {
            images.push({
                original: photo,
                thumbnail: photo.replace(".jpg", "_thumb.jpg")
            });
        });

        return images;
    }

    render() {
        var { photographerId } = this.props;
        var images = this.getImages(photographerId);

        return (
            <ImageGallery 
                showFullscreenButton={false}
                items={images} />
        );
    }
}

export default PhotographerGallery;


// WEBPACK FOOTER //
// ./src/components/photographerGallery.jsx